import Vue from 'vue'
import SeckillOption from './seckill.vue'

const Seckill = Vue.extend(SeckillOption)

export function templateSeckillVue({
  module,
  postMessage,
  addListener,
  removeListener,
  callModule,
  exposeDirective
}) {
  const seckill = new Seckill({
    propsData: {
      module
    },
    methods: {
      postMessage,
      addListener,
      removeListener,
      callModule
    },
    directives: {
      tangramExpose: exposeDirective
    }
  }).$mount()
  return seckill.$el
}
